import { create } from 'zustand';
import { en } from './en';
import { fr } from './fr';
import type { Translations } from './en';

type Language = 'en' | 'fr';

const translations: Record<Language, Translations> = { en, fr };

interface I18nState {
  language: Language;
  t: Translations;
  setLanguage: (lang: Language) => void;
}

export const useI18n = create<I18nState>((set) => ({
  language: 'en',
  t: en,
  setLanguage: (lang) => set({ language: lang, t: translations[lang] }),
}));

export type { Language, Translations };
